// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid, Typography, useMediaQuery } from '@mui/material';
import CustomPaginationCommon from './CustomPaginationCommon';
import { useNavigate } from 'react-router-dom';
import { useAppData } from 'context/AppContext';
import { IUser } from 'types';
import moment from 'moment';
import AccountRoleDropdown from './AccountRoleDropdown';
import AccountStatusDropdown from './AccountStatusDropdown';
import ExpirationDatesDropdown from './ExpirationDatesDropdown';
import { useTheme } from '@emotion/react';
const UsersTable = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [filteredUsers, setFilteredUsers] = useState<IUser[]>([]);
  const [showAll, setShowAll] = useState(false);
  const [accountRole, setAccountRole] = useState<string | null>(null);
  const [accountStatus, setAccountStatus] = useState<string | null>(null);
  const [licenseDateRange, setLicenseDateRange] = useState<{ from: string; to: string } | null>(null);
  const [insuranceDateRange, setInsuranceDateRange] = useState<{ from: string; to: string } | null>(null);
  const [activeDropdown, setActiveDropdown] = React.useState<number | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);


  const {
    users,
  }: {
    users: IUser[];
  } = useAppData();

  // ✅ Filtering Logic
  useEffect(() => {
    setLoading(true); // Start loader
    setTimeout(() => {
      let updatedUsers = [...users];

      // ✅ Filter by Account Role (Ensure case sensitivity)
      if (accountRole) {
        updatedUsers = updatedUsers.filter((user) => user.type.toLowerCase() === accountRole.toLowerCase());
      }

      // ✅ Filter by Account Status
      if (accountStatus) {
        updatedUsers = updatedUsers.filter((user) => user.accountStatus.toLowerCase() === accountStatus.toLowerCase());
      }

      // ✅ Filter by License Expiration Date Range
      if (licenseDateRange?.from && licenseDateRange?.to) {
        updatedUsers = updatedUsers.filter((user) => {
          const licenseDate = new Date(user?.licenseExpiration?.seconds * 1000);
          return licenseDate >= new Date(licenseDateRange.from) && licenseDate <= new Date(licenseDateRange.to);
        });
      }

      // ✅ Filter by Insurance Expiration Date Range
      if (insuranceDateRange?.from && insuranceDateRange?.to) {
        updatedUsers = updatedUsers.filter((user) => {
          const insuranceDate = new Date(user?.insuranceExpiration?.seconds * 1000);
          return insuranceDate >= new Date(insuranceDateRange.from) && insuranceDate <= new Date(insuranceDateRange.to);
        });
      }

      setFilteredUsers(updatedUsers);
      setLoading(false); // Stop loader
      setPage(1); // ✅ Reset page to 1 when filtering
    }, 1000); // Simulate loading
  }, [users, accountRole, accountStatus, licenseDateRange, insuranceDateRange]);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const itemsPerPage = isMobile ? 4 : 6; // 4 per page on mobile, 6 on desktop

  // ✅ Pagination Logic
  const paginatedData = filteredUsers.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handleChangePage = (
    event: any,
    newPage: React.SetStateAction<number>
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: { target: { value: string } }) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickAccountRole = (accountRole: any, userId: string) => {
    if (accountRole === 'content-creator') {
      navigate(`/manage-users/${accountRole}/${userId}`);
    } else if (accountRole === 'standard-user') {
      navigate(`/admin/${accountRole}/${userId}`);
    } else {
      console.log('User type not found');
    }
  };

  const handleAccountChange = (option: string) => setAccountRole(option);
  const handleStatusChange = (status: string) => setAccountStatus(status);
  const handleDateChange = (range: { from: string; to: string }, type: "license" | "insurance") => {
    if (type === "license") setLicenseDateRange(range);
    if (type === "insurance") setInsuranceDateRange(range);
  };
  const handleClearAll = () => {
    setAccountStatus(null); // Reset category filter
    setInsuranceDateRange(null);
    setLicenseDateRange(null);
    setAccountRole(null); // Reset sort option to default
    setShowAll(false); // Reset "show all" state
  };

  const handleDropdownToggle = (dropdownIndex: number) => {
    setActiveDropdown(activeDropdown === dropdownIndex ? null : dropdownIndex);
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage + 1); // Convert from 0-based index to 1-based index
  };


  return (
    <Grid
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      bgcolor={'#F8F8F8'}
      height={"100%"}
      gap={5}
      mb={5}
      px={5}>
      <Box display={'flex'} pt={7} justifyContent={'space-between'} alignItems={'center'}>
        <Box fontWeight={500} fontSize={'28px'} color={'#233F91'}>
          Users
        </Box>
        <Box
          display={"flex"}
          gap={1}
          alignItems={"center"}
          px={2}
        >
          <ExpirationDatesDropdown
            activeDropdown={activeDropdown}
            setActiveDropdown={handleDropdownToggle}
            onExpirationChange={handleDateChange}
            onClearAll={handleClearAll}

          />
          <AccountRoleDropdown
            activeDropdown={activeDropdown}
            setAccountRole={handleDropdownToggle}
            onAccountChange={handleAccountChange}
            onClearAll={handleClearAll}
            accountRole={accountRole}
          />
          <AccountStatusDropdown
            activeDropdown={activeDropdown}
            setAccountStatus={handleDropdownToggle}
            onStatusChange={handleStatusChange}
            onClearAll={handleClearAll}
            accountStatus={accountStatus}
          />


        </Box>
      </Box>

      <Grid item xs={10} >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '35px' }}>
          <div
            style={{
              backgroundColor: '#EFF4FA',
              borderRadius: '15px',
              padding: '24px',
              display: 'flex',
              justifyContent: 'space-between',
              color: '#6A6A6A',
              fontFamily: 'Atten Round New',
            }}>
            <div style={{ fontWeight: '700', fontSize: '17px', width: '8%' }}>
              Name
            </div>
            <div style={{ fontWeight: '700', fontSize: '17px', width: '8%' }}>
              User ID
            </div>
            {/* <div style={{ fontWeight: '700', fontSize: '17px', width: '12%' }}>
              Mobile Number
            </div> */}
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '18.5%' }}>
              Email Address
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '11.5%' }}>
              License Expiration
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '11.5%' }}>
              Insurance Expiration
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              Account Role
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              Account Status
            </div>
          </div>
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '15px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '28px',
            }}>
            {/* {users
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) */}
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="40vh"
              // width="100vw"
              >
                <CircularProgress color="primary" size={60} />
              </Box>
            ) : paginatedData.length === 0 ? (
              <Box
                flex={1}
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
              // width="100vw"
              >
                <Typography
                  display="flex"
                  alignItems="center"
                  fontSize={22}
                  color="#797979"
                  fontWeight={400}
                >
                  No users found.
                </Typography>
              </Box>
            ) : (
              paginatedData.map((user) => (
                <div
                  onClick={() => handleClickAccountRole(user.type, user.id)}
                  key={user?.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // fontSize: '15px !important',
                    fontWeight: '500 !important',
                    color: '#595959',
                    lineHeight: '24px',
                    fontFamily: 'Atten Round New !important',
                  }}>
                  <div style={{ width: '8%', cursor: 'pointer' }}>{user?.firstName}</div>
                  <div style={{ width: '8%', cursor: 'pointer' }}>{user?.id.slice(0, 5)}...</div>
                  {/* <div style={{ width: '12%' }}>200-200-2020</div> */}
                  <div style={{ width: '18.5%', cursor: 'pointer' }}>{user.email}</div>
                  <div style={{ width: '11.5%', cursor: 'pointer' }}>
                    {/* {new Date(user?.licenseExpiration?.seconds * 1000).toLocaleString()} */}
                    {new Date(user?.licenseExpiration?.seconds * 1000).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    })}

                  </div>
                  <div style={{ width: '11.5%', cursor: 'pointer' }}>
                    {/* {new Date(user?.insuranceExpiration?.seconds * 1000).toLocaleString()} */}
                    {new Date(user?.insuranceExpiration?.seconds * 1000).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    })}

                  </div>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>
                    {user.type}
                  </div>
                  <div
                    style={{
                      width: '12.5%',
                      display: 'flex',
                      alignItems: 'center',

                      // gap: '5px',
                    }}>
                    <span style={{ width: '100px', cursor: 'pointer' }}>
                      {user?.accountStatus === 'approve'
                        ? 'Approved'
                        : user?.accountStatus === 'pending'
                          ? 'Pending'
                          : user?.accountStatus}

                    </span>
                    <div style={{ marginLeft: '10px' }}>
                      {user?.accountStatus === 'pending' ? (
                        <img src="/assets/icons/pending.svg" alt="Pending" />
                      ) : user?.accountStatus === 'approve' ? (
                        <img src="/assets/icons/activeDotted.svg" alt="Active" />
                      ) : (
                        <img src="/assets/icons/deActive.svg" alt="Deactivated" />
                      )}
                    </div>

                  </div>
                </div>
              ))
            )}
            <div
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'center',
              }}>
              {/* <CustomPaginationCommon
                count={users.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
              <CustomPaginationCommon
                count={filteredUsers?.length}
                page={page - 1}
                rowsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default UsersTable;
